import { ContainerFormComponentWrapper } from './ContainerFormElementWrapper'
import { RepeatableFormComponentWrapper } from './RepeatableFormComponentWrapper'
import { StandardFormComponentWrapper } from './StandardFormElementWrapper'
import type { FormComponentWrapperProps } from './types'
export const FormComponentWrapper = ({ component, index, containerId }: FormComponentWrapperProps) => {
	if (component.action === 'delete') {
		return
	}

	if (component.name === 'repeatable') {
		return <RepeatableFormComponentWrapper component={component} index={index} containerId={containerId} />
	}

	if (component.name === 'container') {
		return <ContainerFormComponentWrapper component={component} index={index} containerId={containerId} />
	}
	return <StandardFormComponentWrapper component={component} index={index} containerId={containerId} />
}
